module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/CardSet-c76e1bb219db85a731cabe256396211d.png";